
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    V4Ja: () => import('@/terms_of_service/v4/ja/Index.vue'),
    V4Vi: () => import('@/terms_of_service/v4/vi/Index.vue'),
    V4En: () => import('@/terms_of_service/v4/en/Index.vue'),
    V4Id: () => import('@/terms_of_service/v4/id/Index.vue')
  }
})
export default class Page extends Vue {
  @Prop({ type: Number, required: true })
  public version!: number;

  @Prop({ type: String, required: true })
  public language!: string;

  private async created(): Promise<void> {
    // 言語切り替え時にフラグを寝かせてロードする
    this.$watch(
      (): string => `${this.version}_${this.language}`,
      (): unknown => this.$emit('isLoading', true)
    );
  }

  public onMount(): void {
    this.$emit('isLoading', false);
  }
}
